var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wizard',{attrs:{"title":_vm.title,"progress":_vm.progress},on:{"close":function($event){return _vm.$emit('close')}}},[_c('transition-fade',[_c('router-view',{staticClass:"wizard__screen",attrs:{"eventId":_vm.eventId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }